module.exports = __webpack_public_path__ + "static/img/30017 (3).5d2e0de.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30017 (3).webp
// module id = Gpsl
// module chunks = 14